module.exports = __webpack_public_path__ + "static/media/tony-moaton.4673e375.md";